import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { get, isEmpty, isNil } from 'lodash';
import { DEFAULT_INVALID_VALUE } from '../../../../utilities/FormattingUtilities';
import useRecordContext from '../../../../utilities/RecordContextProviderUtilities';
import { useApiDataFetch } from '../../../../utilities/Hooks';

const ENTITY_COUNT_ENDPOINT = '/ipm/v1/admin/virtualInfrastructureConfig/findById/';
const ENTITY_COUNT_PATH = 'virtualization.entityCount';
const DEFAULT_ENTITY_COUNT = 0;

/**
 * Fetches and displays entity count for a specific virtual infrastructure entity
 * @param {Object} props - Component props
 * @param {string} props.selectedId - Entity ID to fetch count for
 */
const TotalEntitiesValue = ({ selectedId }) => {
    const selector = useMemo(() => {
        return (data) => {
            if (isNil(data)) {
                return DEFAULT_ENTITY_COUNT;
            }
            return get(data, ENTITY_COUNT_PATH, DEFAULT_ENTITY_COUNT);
        };
    }, []);

    const entityCount = useApiDataFetch({
        endpoint: ENTITY_COUNT_ENDPOINT,
        params: { selectedId },
        selector,
        initialState: DEFAULT_ENTITY_COUNT,
    });

    return <div>{entityCount}</div>;
};

TotalEntitiesValue.propTypes = {
    selectedId: PropTypes.string.isRequired,
};

/**
 * Displays total entities count for current virtual infrastructure entity
 * Shows invalid value placeholder if no entity is selected
 */
const TotalEntitiesFieldValue = () => {
    const { id: selectedId } = useRecordContext();

    if (isEmpty(selectedId)) {
        return <>{DEFAULT_INVALID_VALUE}</>;
    }

    return <TotalEntitiesValue selectedId={selectedId} />;
};

export default TotalEntitiesFieldValue;
